import { Injectable } from '@angular/core';
import axios from 'axios';
import { environment } from 'src/environments/environment';
import { AttorneyItem } from '../attorney/attorney.service';
import { Address } from '../cases/cases.service';

export type LawFirmItem = {
  id: number;
  name: string;
  has_mokk_cookie: boolean;
  address: Address | null;
  email: null | string;
  phone: null | string;
  attorneys: AttorneyItem[];
};

type GetLawFirmsResponse = {
  law_firms: LawFirmItem[];
};

type CreateLawFirmParams = {
  name: string;
  address: Address | null;
  email: null | string;
  phone: null | string;
  attorneys: number[];
};

type CreateLawFirmResponse = {
  law_firm: LawFirmItem;
};

type UpdateLawFirmParams = {
  name: string;
  address: Address | null;
  email: null | string;
  phone: null | string;
  attorneys: number[];
};

type UpdateLawFirmMokkCookieParams = {
  mokk_cookie: string | null;
};

type UpdateLawFirmMokkCookieResponse = {
  law_firm: LawFirmItem;
};

@Injectable({
  providedIn: 'root'
})
export class LawFirmService {
  async listLawFirms(name?: string): Promise<LawFirmItem[]> {
    const result = await axios.get<GetLawFirmsResponse>(`${environment.baseUrl}/api/law-firm`, {
      params: {
        name,
      },
    });
    return result.data.law_firms;
  }

  async create(params: CreateLawFirmParams): Promise<LawFirmItem> {
    const result = await axios.post<CreateLawFirmResponse>(`${environment.baseUrl}/api/law-firm`, params);
    return result.data.law_firm;
  }

  async update(id: number, params: UpdateLawFirmParams): Promise<void> {
    await axios.post(`${environment.baseUrl}/api/law-firm/${id}`, {
      ...params,
      _method: 'PUT',
    });
  }

  async delete(id: number): Promise<void> {
    await axios.delete(`${environment.baseUrl}/api/law-firm/${id}`);
  }

  async updateMokkCookie(
    id: number,
    params: UpdateLawFirmMokkCookieParams,
  ): Promise<LawFirmItem> {
    const result = await axios.patch<UpdateLawFirmMokkCookieResponse>(
      `${environment.baseUrl}/api/law-firm/${id}/mokk-cookie`,
      params,
    );
    return result.data.law_firm;
  }
}
